import React from "react";
import axios from "axios";
export default axios.create({
  baseURL: `https://sankoenerji.com.tr`,
  //baseURL: `https://demo.sankoenerji.com.tr`,
  //baseURL: `http://localhost:44307`,
  headers: {
    "Content-Type": "application/json",
  },
  credentials: "same-origin",
});
